(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.EventsController = (function(superClass) {
    extend(EventsController, superClass);

    function EventsController(scope, transitions, modal, http, service, state, _1, _2, _3, ngModal) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state;
      this.ngModal = ngModal;
      this.numberOfEvents = bind(this.numberOfEvents, this);
      this.eventStatus = bind(this.eventStatus, this);
      this.eventsInputDisabled = bind(this.eventsInputDisabled, this);
      this.decrementEvents = bind(this.decrementEvents, this);
      this.incrementEvents = bind(this.incrementEvents, this);
      this.editFormHelper = bind(this.editFormHelper, this);
      this.editForm = bind(this.editForm, this);
      this.addForm = bind(this.addForm, this);
      EventsController.__super__.constructor.apply(this, arguments);
      this.service.onDataLoaded(this.scope, (function(_this) {
        return function() {
          var events, ref, results, type;
          ref = _this.service.fpcResult.events;
          results = [];
          for (type in ref) {
            events = ref[type];
            if (events.length > _this.service.fpcResult.data[type]) {
              results.push(_this.service.fpcResult.data[type] = events.length);
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
      })(this));
    }

    EventsController.prototype.addForm = function(formType) {
      return this.service.save(this.service.fpcResult.id).then((function(_this) {
        return function() {
          return {
            fertilizer: function() {
              return _this.ngModal.openFertilizerForm(_this.service.field, _this.service.year, null);
            },
            cover_crop: function() {
              return _this.ngModal.openCoverCropForm(_this.service.field, _this.service.year, null);
            },
            spraying: function() {
              return _this.ngModal.openSprayingForm(_this.service.field, _this.service.year, null);
            },
            planting: function() {
              return _this.ngModal.openPlantingForm(_this.service.field, _this.service.year, null, _this.service.mfCrop, null, true);
            }
          }[formType]().modalRef.result.then(function() {
            return _this.service.loadFieldprint(_this.service.fpcResult.id);
          })["catch"](_.noop);
        };
      })(this));
    };

    EventsController.prototype.editForm = function(formType) {
      return this.service.save(this.service.fpcResult.id).then((function(_this) {
        return function() {
          return _this.editFormHelper(formType);
        };
      })(this));
    };

    EventsController.prototype.editFormHelper = function(formType, events) {
      var afterForm;
      if (events == null) {
        events = null;
      }
      if (events == null) {
        events = _.uniq(this.service.fpcResult.events[formType]);
      }
      afterForm = (function(_this) {
        return function() {
          if (events.length > 0) {
            return _this.editFormHelper(formType, events);
          } else {
            return _this.service.loadFieldprint(_this.service.fpcResult.id);
          }
        };
      })(this);
      return {
        fertilizer: (function(_this) {
          return function() {
            return _this.ngModal.openFertilizerForm(_this.service.field, _this.service.year, {
              layers_id: events.pop(),
              mode: 'Edit'
            });
          };
        })(this),
        cover_crop: (function(_this) {
          return function() {
            return _this.ngModal.openCoverCropForm(_this.service.field, _this.service.year, {
              layers_id: events.pop(),
              mode: 'Edit'
            });
          };
        })(this),
        spraying: (function(_this) {
          return function() {
            return _this.ngModal.openSprayingForm(_this.service.field, _this.service.year, {
              layers_id: events.pop(),
              mode: 'Edit'
            });
          };
        })(this),
        planting: (function(_this) {
          return function() {
            return _this.ngModal.openPlantingForm(_this.service.field, _this.service.year, {
              layers_id: events.pop(),
              mode: 'Edit'
            });
          };
        })(this)
      }[formType]().modalRef.result.then(afterForm)["catch"](afterForm);
    };

    EventsController.prototype.incrementEvents = function(inputName) {
      return this.service.fpcResult.data[inputName]++;
    };

    EventsController.prototype.decrementEvents = function(inputName) {
      return this.service.fpcResult.data[inputName]--;
    };

    EventsController.prototype.eventsInputDisabled = function(inputName) {
      var minimumEvents, ref, ref1;
      if ((((ref = this.service.fpcResult) != null ? ref.events : void 0) == null) || (this.service.fpcResult.events[inputName] == null)) {
        return true;
      }
      if (this.service.fpcResult.events[inputName].length === this.service.fpcResult.data[inputName]) {
        return true;
      }
      minimumEvents = ((ref1 = this.service.config[this.service.crop].steps.value['Production Practices'].value.events.value[inputName].value.minimum) != null ? ref1.value : void 0) || 0;
      return this.service.fpcResult.data[inputName] <= minimumEvents;
    };

    EventsController.prototype.eventStatus = function(inputName) {
      var eventsIntended, eventsRecorded, ref;
      if (this.service.fpcResult.events == null) {
        return '';
      }
      eventsIntended = this.service.fpcResult.data[inputName];
      eventsRecorded = (ref = this.service.fpcResult.events[inputName]) != null ? ref.length : void 0;
      if (eventsIntended > eventsRecorded && eventsRecorded === 0) {
        return 'Unstarted';
      }
      if (eventsIntended > eventsRecorded && eventsRecorded > 0) {
        return 'In Process';
      }
      if (eventsIntended === eventsRecorded) {
        return 'Done';
      }
      return '';
    };

    EventsController.prototype.numberOfEvents = function(formType) {
      return _.uniq(this.service.fpcResult.events[formType]).length;
    };

    return EventsController;

  })(Controller);

}).call(this);
